<!-- AI机器人测评功能已隐藏 -->
<!-- <div class="p-d-flex p-ai-center p-jc-between" style="position: absolute;  z-index: 100;">
    <div style="position: relative;">
        <div class="robot" style="width:280px;height:200px;left:-320px;">
            <img src="assets/file/image/rbft.png" style="width: 100px;height:100px;">
            <div class="robot">
                <img class="robot-back" style="width: 100px;height:100px;" src="assets/file/image/rbfb.png" >
                <div id="robot" class="robot" style="cursor: pointer;">
                    <img src="assets/file/image/rbf.png" >
                    <div class="scan-center scan-stop" style="visibility:block;">
                        <img class="leftEye" src="assets/file/image/rbfy.png" style="margin-right:5px;">
                        <img class="rightEye" src="assets/file/image/rbfy.png" >
                    </div>
                    <div class="scan-center scan-run" style="visibility:hidden;">
                        扫描中
                    </div>
                </div>
            </div>
        </div>
        <div id="scanItems" class="scanItems" style="position:absolute;top:200px;left:-320px;width:280px;background-color: #FFFFFF;border-radius: 16px;visibility:hidden;">
            <div style="margin-top:-10px;width:280px;display:flex;justify-content: center;">
                <div style="width:0;height:0;border-bottom:20px solid #FFFFFF;border-left: 20px solid rgba(0,0,0,0);border-right: 20px solid rgba(0,0,0,0);"> </div>
            </div>
            <div class="scanChild" style="width:280px;padding:10px;background-color: #FFF;border-radius: 16px;">
                <div style="width:100%;height:34px;background: linear-gradient(95.4deg, #63E5E2 -14.47%, #0C58ED 45%, #AB1CF7 103.62%);border-radius: 8px;
                        display: flex;justify-content: space-between;align-items: center; font-size: 16px; padding: 10px; color: #FFF; font-weight: 700;">
                    <span>测评项目</span>
                    <span>风险等级</span>
                </div>
                <p-scrollPanel [style]="{width: '100%', height: '500px'}">
                    <ng-container *ngFor="let item of scanItems">
                        <div style="width:100%;font-size: 16px;margin-top:20px;border-bottom: 1px solid #EBEBEB;
                                padding-bottom: 10px;font-family: 'Source Han Sans CN'; font-style: normal; font-weight: 500;color:#000;">
                            <div>
                                <div style="font-size:16px;font-weight:500;display: flex;justify-content: space-between;align-items: center;width:100%;">
                                    <label>{{item['key']}}</label>
                                    <label [ngStyle]="{'color': item['status'] == 1 ? riskColor[item['riskType']] : 'green' }"> 
                                        {{item['status'] == 1 ? riskType[item['riskType']] : '正常'}}
                                    </label>
                                </div>
                                <div style="font-size:14px;font-weight:500;margin-top:5px;color:#999999;">
                                     {{item['label']}}
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </p-scrollPanel>
            </div>
        </div>
    </div>
</div> -->
<!-- AI机器人测评功能已隐藏结束 -->
<div #viewComponent style="margin: 0;padding: 0;height:100%;width:100%;">
    <div class="header">
        <div>
            司机审核
        </div>
        <div>
            <i class="pi pi-times p-cursor" (click)="closeDetail()"></i>
        </div>
    </div>
    <div class="body" style="padding: 23px 30px 0px;position: relative;">
        <table>
            <tr style="width:100%;height:100%;">
                <td class="panel-left">
                    <div class="panel-detail panel-background">
                        <div class="panel-detail-header">
                            <div class="company-name">
                                {{localDriverDetail['realname']}}</div>
                            <div class="company-tel">
                                <img src="assets/icon/map-location.png" alt="">&nbsp;
                                <span *ngIf="localDriverDetail['formattedAddress']">{{localDriverDetail.formattedAddress}}
                                    <span class="auditor" [pTooltip]="'定位时间：'+this.bc.setCreateTime(localDriverDetail['addTime']*1000)"
                                        tooltipPosition="top">
                                        （{{this.bc.dateDiff(localDriverDetail['addTime']*1000)}}）</span>
                                </span>
                                <span class="auditor" *ngIf="!localDriverDetail['formattedAddress']">暂无</span>
                            </div>
                            <div class="panel-detail-status p-d-flex p-ai-center p-jc-center">
                                <img class="p-mr-3" *ngIf="localDriverDetail['politicalOutlook']==1"
                                    src="assets/icon/party-emblem.png" pTooltip="政治面貌：党员" tooltipPosition="top" alt="">
                                
                                <img class="p-mr-3" *ngIf="localDriverDetail['source']==0" [pTooltip]="'来源：'+this.source[localDriverDetail['source']]"
                                    tooltipPosition="top" src="assets/icon/pc.png" alt="">
                                <img class="p-mr-3" *ngIf="localDriverDetail['source']==1" [pTooltip]="'来源：'+this.source[localDriverDetail['source']]"
                                    tooltipPosition="top" src="assets/icon/execl.png" alt="">
                                <img class="p-mr-3" *ngIf="localDriverDetail['source']==2" [pTooltip]="'来源：'+this.source[localDriverDetail['source']]"
                                    tooltipPosition="top" src="assets/icon/wechat.png" alt="">
                                <img class="p-mr-3" *ngIf="localDriverDetail['source']==3" [pTooltip]="'来源：'+this.source[localDriverDetail['source']]"
                                    tooltipPosition="top" src="assets/icon/mobile.png" alt="">

                                <div class="auditor p-mr-3" *ngIf="this.bc.getAge(localDriverDetail['birthDate'])>0">
                                    {{this.bc.getAge(localDriverDetail['birthDate'])}}周岁</div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="this.bc.getAge(localDriverDetail['birthDate'])>0 && (this.bc.getAge(localDriverDetail['birthDate'])<18 || this.bc.getAge(localDriverDetail['birthDate'])>60)"
                                    class="company-contract p-mr-3">
                                    <span *ngIf="this.bc.getAge(localDriverDetail['birthDate'])<18">年龄低于法定年限18周岁</span>
                                    <span *ngIf="this.bc.getAge(localDriverDetail['birthDate'])>60">年龄高于法定年限60周岁</span>
                                </div>

                                <div [class]="localDriverDetail['useStatus']==0 ? 'company-status' : 'company-permit'">
                                    {{useStatus[localDriverDetail['useStatus']]}}</div>

                                <div class="company-contract" *ngIf="localDriverDetail['checkFlag']==1">
                                    {{checkFlag[localDriverDetail['checkFlag']]}}</div>
                                <div class="company-success" *ngIf="localDriverDetail['checkFlag']==2">
                                    {{checkFlag[localDriverDetail['checkFlag']]}}</div>
                                <div class="company-permit" *ngIf="localDriverDetail['checkFlag']==3">
                                    不通过原因：{{localDriverDetail['checkLog']}}</div>

                                <div class="company-contract p-mr-3"
                                    *ngIf="bc.getExpireDays(localDriverDetail['endUseDate'],'',localDriverDetail['expiredWarnDay']) > 0">
                                    身份证{{bc.getExpireDays(localDriverDetail['endUseDate'],'',localDriverDetail['expiredWarnDay'])}}天后过期</div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="bc.getExpireDays(localDriverDetail['endUseDate'],'',localDriverDetail['expiredWarnDay']) < 0">
                                    身份证已过期{{bc.getExpireDays(localDriverDetail['endUseDate'],1,localDriverDetail['expiredWarnDay'])}}天</div>
    
                                <div class="company-contract p-mr-3"
                                    *ngIf="bc.getExpireDays(localDriverDetail['drivingEndUseDate'],'',localDriverDetail['expiredWarnDay']) > 0">
                                    驾驶证{{bc.getExpireDays(localDriverDetail['drivingEndUseDate'],'',localDriverDetail['expiredWarnDay'])}}天后过期</div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="bc.getExpireDays(localDriverDetail['drivingEndUseDate'],'',localDriverDetail['expiredWarnDay']) < 0">
                                    驾驶证已过期{{bc.getExpireDays(localDriverDetail['drivingEndUseDate'],1,localDriverDetail['expiredWarnDay'])}}天</div>
    
                                <div class="company-contract p-mr-3"
                                    *ngIf="bc.getExpireDays(localDriverDetail['qualificationCertExpireTime'],'',localDriverDetail['expiredWarnDay']) > 0">
                                    从业资格证{{bc.getExpireDays(localDriverDetail['qualificationCertExpireTime'],'',localDriverDetail['expiredWarnDay'])}}天后过期
                                </div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="bc.getExpireDays(localDriverDetail['qualificationCertExpireTime'],'',localDriverDetail['expiredWarnDay']) < 0">
                                    从业资格证已过期{{bc.getExpireDays(localDriverDetail['qualificationCertExpireTime'],1,localDriverDetail['expiredWarnDay'])}}天
                                </div>

                            </div>
                        </div>
                        <div class="hr"></div>
                        <form class="detail-form" action="">
                            <div class="table-detail">
                                <div class="table-rows">
                                    <div class="table-tr">
                                        司机姓名
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{localDriverDetail['realname']}}
                                    </div>
                                    <div class="table-tr">
                                        政治面貌
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.politicalOutlookMap[localDriverDetail['politicalOutlook']]}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        性别
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.sex[localDriverDetail['sex']]}}
                                    </div>
                                    <div class="table-tr">
                                        出生年月
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localDriverDetail['birthDate']*1000,'yyyy-MM-dd')}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        手机号
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{localDriverDetail['mobilePhone']}}
                                    </div>
                                    <div class="table-tr">
                                        身份证号
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{localDriverDetail['idCardNo']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        身份证有效期起
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localDriverDetail['startUseDate']*1000,'yyyy-MM-dd')}}
                                    </div>
                                    <div class="table-tr">
                                        身份证有效期止
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localDriverDetail['endUseDate']*1000,'yyyy-MM-dd')}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">地址</div>
                                    <div class="table-td table-td-address">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{localDriverDetail['address']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        从业资格证
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{localDriverDetail['qualificationCertNo']}}
                                    </div>
                                    <div class="table-tr">
                                        从业资格证失效日期
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localDriverDetail['qualificationCertExpireTime']*1000,'yyyy-MM-dd')}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        准驾车型
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.driverTypeMap[localDriverDetail['driverType']]}}
                                    </div>
                                    <div class="table-tr">
                                        档案编号
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{localDriverDetail['drivingLicenseNo']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        驾驶证有效期起
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localDriverDetail['drivingStartUseDate']*1000,'yyyy-MM-dd')}}
                                    </div>
                                    <div class="table-tr">
                                        驾驶证有效期止
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localDriverDetail['drivingEndUseDate']*1000,'yyyy-MM-dd')}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        驾驶证发证机关
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        <span [pTooltip]="localDriverDetail['issuingOrganizations']"
                                            tooltipPosition="top">{{localDriverDetail['issuingOrganizations']}}</span>
                                    </div>
                                    <div class="table-tr">
                                        从业资格证颁发机构所在地
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        <span [pTooltip]="qualificationCertIssueArea"
                                            tooltipPosition="top">{{qualificationCertIssueArea}}</span>
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        从业资格证颁发机构所在地
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        <span [pTooltip]="qualificationCertIssueArea"
                                            tooltipPosition="top">{{qualificationCertIssueArea}}</span>
                                    </div>
                                    <div class="table-tr">
                                        注册时间
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localDriverDetail['createTime']*1000)}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        来源
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.source[localDriverDetail['source']]}}
                                    </div>
                                    <div class="table-tr">备注</div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{localDriverDetail['remark']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        审核时间
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localDriverDetail['checkTime']*1000)}}
                                    </div>
                                    <div class="table-tr">
                                        审核人员
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{localDriverDetail['checkName']}}
                                    </div>
                                </div>
                            </div>
                        </form>

                        <!-- 委托代开协议 -->
                        <form class="detail-form" action="">
                            <div class="table-detail">
                                <div class="table-rows">
                                    <div class="table-tr">委托代开协议</div>
                                    <div class="table-td table-td-address">
                                        <!-- <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton> -->
                                        <a href="javascript:;" pRipple class="edit-font"
                                            (click)="showFadadaDriverAgree(localDriverDetail)">{{this.signStatus[localDriverDetail['signStatus']]}}</a>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <!--关联信息-->
                        <form class="detail-form" action="">
                            <div class="table-title">关联信息</div>
                            <p-accordion>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        我的车辆（{{this.relTruckList.length}}）
                                        <div *ngFor="let item of relTruckList ;let i = index">
                                            <p-chip *ngIf="i<6" [label]="item['plateNumber']" [style]="{'margin-left': '10px'}"
                                                styleClass="p-mr-2 custom-chip"></p-chip>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">序号</div>
                                            <div class="table-line">车牌号</div>
                                            <div class="table-line">车辆类型</div>
                                            <div class="table-line">人车照片</div>
                                        </div>
                                        <div class="table-rows" *ngIf="relTruckList.length==0">
                                            <div class="table-line" *ngIf="!loadingRelInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingRelInfo">
                                                <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows"
                                            *ngFor="let item of relTruckList ;let i = index">
                                            <div class="table-line">
                                                {{i+1}}
                                            </div>
                                            <div class="table-line">
                                                <a href="javascript:;" pRipple class="edit-font"
                                                    (click)="showTruckDetail(item)">{{item.plateNumber}}
                                                </a>
                                            </div>
                                            <div class="table-line">
                                                {{this.vehicleTypeMap[item.vehicleType]}}
                                            </div>
                                            <div class="table-line">
                                                <ng-container
                                                    *ngIf="item.driverTruckPhoto == '' || item.driverTruckPhoto == null">
                                                    <span style="color: red;">未上传</span>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="item.driverTruckPhoto != '' && item.driverTruckPhoto != null">
                                                    <a href="javascript:;" pRipple class="edit-font"
                                                        (click)="checkDriverTruckPhoto(item)"
                                                        style="color: #4ea844;">已上传</a>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">银行卡（{{this.bankAccountList.length}}）
                                        <div *ngFor="let item of bankAccountList;let i = index">
                                            <p-chip *ngIf="i<3" [label]="item['accountNo']+'('+item['cardType']+')'" style="margin-left: 10px;"
                                                styleClass="p-mr-2 custom-chip"></p-chip>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">序号</div>
                                            <div class="table-line">所属银行</div>
                                            <div class="table-line">银行卡号</div>
                                            <div class="table-line">是否强制绑定</div>
                                        </div>
                                        <div class="table-rows" *ngIf="bankAccountList.length==0">
                                            <div class="table-line" *ngIf="!loadingRelInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingRelInfo">
                                                <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows"
                                            *ngFor="let item of bankAccountList;let i = index">
                                            <div class="table-line">
                                                {{i+1}}
                                            </div>
                                            <div class="table-line">
                                                <span [pTooltip]="item.cardType"
                                                    tooltipPosition="top">{{item.cardType}}</span>
                                            </div>
                                            <div class="table-line">
                                                <span [pTooltip]="item.accountNo"
                                                    tooltipPosition="top">{{item.accountNo}}</span>
                                            </div>
                                            <div class="table-line">
                                                {{item.isForceName}}
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab>
                            </p-accordion>
                        </form>
                    </div>
                </td>
                <td class="panel-right">
                    <div class="panel-list panel-background">
                        <div class="photo-detail">
                            <div class="img-describe">{{imgDescribe}}</div>
                            <div class="img-container">
                                <div class="img-preview">
                                    <img [src]="imgPriview || thumbnailImageSrc[0]['url']"
                                        class="img-preview-img" *ngIf="imgPriview || thumbnailImageSrc.length > 0" (click)="previewThumbnailImage()">
                                </div>
                                <div class="function-container">
                                    <div class="function-item turnLeft" (click)="handleTurnLeft()">
                                        <img src="assets/icon/tleft.png" alt="">
                                    </div>
                                    <div class="function-item turnRight" (click)="handleTurnright()">
                                        <img src="assets/icon/tright.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="img-list">
                                <div class="img-list-previous">
                                    <img src="assets/icon/Vector 34.png" alt="">
                                </div>
                                <div style="margin: 0 40px;" class="p-d-flex p-ai-center p-jc-center">
                                    <ng-container *ngFor="let item of thumbnailImageSrc;let i = index;">
                                        <div class="img-list-item" [ngClass]="{'onactive': previewImgIndex == i}">
                                            <img [src]="item.url" (click)="handlePreviewImgClick(item,i)">
                                            <div class="img-describe-little-mask">
                                                <div class="img-describe-little">{{item.title}}</div>    
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                                <div class="img-list-next">
                                    <img src="assets/icon/Vector 35.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="photo-detail">
                            <!--图片描述 -->
                            <div class="img-describe">审核日志</div>
                            <div style="height: 250px;overflow-y: auto;">
                                <p-timeline [value]="checkList">
                                    <ng-template pTemplate="content" let-event>
                                        {{this.bc.setCreateTime(event.createTime*1000)}}
                                        <br>
                                        {{event.creatorName}}
                                        <br>
                                        <span [style]="{'color': this.getCheckFlag(event.status)}">{{event.remark}}</span>    
                                    </ng-template>
                                    <ng-template pTemplate="opposite" let-event>
                                        <p-tag [value]="this.checkFlag[event.status]" [rounded]="true"
                                            [style]="{'background-color': this.getCheckFlag(event.status)}"></p-tag>
                                    </ng-template>
                                </p-timeline>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
        <div style="position:fixed;bottom:20px;right:30px;">
            <button pButton type="button" label="审核通过" class="p-mr-2" (click)="checkDriver(10)"></button>
            <button pButton type="button" label="审核不通过" (click)="checkDriverDialog = true"></button>
        </div>
    </div>
</div>

<p-dialog  class="edit-order" [(visible)]="checkDriverDialog" position="center"
    [dismissableMask]="false" [modal]="true" [style]="{width:'40%', overFlow:'auto'}" [draggable]="true"
    [resizable]="false">
    <ng-template pTemplate="header">
        <div >
            审核不通过 <i class="pi pi-info-circle" pTooltip="审核不通过，会默认添加扫描风险项" tooltipPosition="top"></i>
        </div>
    </ng-template>
    <form [formGroup]="checkDriverForm" style="background-color: #ffffff;border-radius: 12px;padding:24px 16px;">
        <div>
            <label for="checkLog" class="label_common">审核不通过原因</label>
            <textarea pInputTextarea formControlName="checkLog" style="width:98%"></textarea>
        </div>
        <small *ngIf="bc.checkFormItem(this.checkDriverForm, 'checkLog')" class="p-error block error-msg">
            请填写审核不通过原因
        </small>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="checkDriver(15)" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消" (click)="checkDriverDialog = flase"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 强制审核通过 -->
<p-dialog header="中风险审核确认" class="edit-order" [(visible)]="forceCheckDriverDialog" position="center"
    [dismissableMask]="false" [modal]="true" [style]="{width:'40%', overFlow:'auto'}" [draggable]="true" [resizable]="false">
    <ng-container *ngFor="let item of scanItems">
        <div >
            <label class="p-mr-2">
                {{item['key']}}:
            </label>
            <span>
                {{item['label']}}
            </span>
        </div>
    </ng-container>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="saveCheckDriver(10, '确认强制审核通过当前司机？')" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消" (click)="forceCheckDriverDialog = flase"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<app-common-confirm></app-common-confirm>

<!--查看法大大协议开始-->
<p-dialog [header]="agreeHeaderTitle" class="edit-order" *ngIf="showFadadaDriverFlag" [(visible)]="showFadadaDriverFlag" position="center" [dismissableMask] = "true"
        [modal]="true" [style]="{width:'60%', overFlow:'auto'}" [baseZIndex]="10000">
    <iframe sandbox="allow-same-origin allow-scripts allow-top-navigation allow-forms" scrolling='auto' frameborder='0' [src]="safeUrl" [style]="{width:'100%',height:'700px'}"></iframe>
</p-dialog>
<!--查看法大大协议结束-->


<!-- 车辆详情弹窗 -->
<p-detail-sidebar *ngIf="showTruckDetailDialog" [(visible)]="showTruckDetailDialog" [showCloseIcon]="false"
    position="right" [style]="{width: percentWidth - 10 + '%'}" transitionOptions="600ms ease-in-out" appendTo="body">
    <app-truck-detail [truckDetail]="truckDetail" (onClose)="showTruckDetailDialog = false"
        [percentWidth]="percentWidth - 10">
    </app-truck-detail>
</p-detail-sidebar>

